export const MAX_NAME_LENGTH = 100;
export const MIN_NAME_LENGTH = 1;
export const NEW_DATA_COLLECTION_PATH = "/data_collections/new";
export const NOT_AUTHORIZED_PATH = "/not-authorized";
export const ERROR_PATH = "/error";
export const STUDY_TEAM_SPACE_PATH = "/study_team_space";
export const RULES_KEY = "ar_acc";
export const OPFAB_PATH = "/main/";
export const MANAGE_PERMISSIONS = "/permissions";
